<script setup lang="ts">
const clients = [
  'Franklin Templeton',
  'Genworth Insurance',
  'Thorntons Solicitors',
  'University of Edinburgh',
  'Scottish Government',
  'Church of England',
  'Shepherd and Wedderburn',
  'Scottish Rugby',
  'Newbury College',
  'Digital Agencies',
]

const marqueeRef = ref<HTMLElement>()
const contentWidth = ref(0)

onMounted(() => {
  nextTick(() => {
    if (marqueeRef.value) {
      const firstContent = marqueeRef.value.querySelector('.marquee-content') as HTMLElement
      if (firstContent) {
        contentWidth.value = firstContent.offsetWidth
      }
    }
  })
})
</script>

<template>
  <div class="relative overflow-hidden py-8 w-full">
    <!-- Fade edges -->
    <div class="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-gray-50 dark:from-dark-500 to-transparent z-10 pointer-events-none" />
    <div class="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-gray-50 dark:from-dark-500 to-transparent z-10 pointer-events-none" />

    <!-- Marquee track -->
    <div
      ref="marqueeRef"
      class="marquee-track"
      :style="contentWidth ? `--content-width: ${contentWidth}px` : ''"
    >
      <div class="marquee-content">
        <span
          v-for="client in clients"
          :key="client"
          class="text-slate-700/75 dark:text-white/50 whitespace-nowrap text-sm md:text-base px-8"
        >
          {{ client }}
        </span>
      </div>
      <div class="marquee-content" aria-hidden="true">
        <span
          v-for="client in clients"
          :key="`dup-${client}`"
          class="text-slate-700/75 dark:text-white/50 whitespace-nowrap text-sm md:text-base px-8"
        >
          {{ client }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.marquee-track {
  display: flex;
  width: fit-content;
  animation: scroll 45s linear infinite;
}

.marquee-content {
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(var(--content-width, 50%) * -1));
  }
}
</style>
